export function failNever(x: never, error: string): never {
  throw new Error(`Unexpected error: ${error}`);
}
